import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { HttpClient } from "@angular/common/http";
import { GetUsliIdsResponse } from "./mex-grid-page.model";

declare let $: any; //eslint-disable-line
//import * as $ from 'jquery';
@Injectable({
  providedIn: "root",
})
export class MexGridPageDataService {
  constructor(private http: HttpClient) {}

  getGridMeta(
    pg: string,
    cut: string,
    company: string,
    source?: string,
  ): Observable<any> {
    let url = `${window.apiUrl}/grid_meta/?pg=${encodeURIComponent(
      pg,
    )}&cut=${cut}&company=${company}`;
    url = source ? `${url}&source=${source}` : url;
    return this.http.get(url);
  }

  getSarToNmvLinksData(
    ticker: string,
    cut: string,
    pg: string,
    source: string,
  ): Observable<any> {
    return this.http.get(
      `${window.apiUrl}/api/get_sar_to_nmv_links/?ticker=${escape(
        ticker,
      )}&cut=${escape(cut)}&pg=${escape(pg)}&source=${escape(source)}`,
    );
  }

  getAllPg(params, count, isForecast) {
    // example : /api/default_pg?pg=IS&cut=NMV&ticker=29M_AU&source=forecast&growthType=Analytics&revision=Current&basis=All&depth=default&pg_seq=1
    //default_pg?pg=IS&cut=NMV&ticker=29M_AU&source=historical&growthType=Analytics&revision=Current&basis=All&depth=default&pg_seq=1
    const url = `/api/default_pg?pg=${escape(params.pg)}&cut=${escape(
      params.cut,
    )}&ticker=${escape(params.ticker)}&source=${
      isForecast ? "forecast" : "historical"
    }&growthType=Analytics&revision=Current&pg_seq=${count}`;
    return this.http.get(`${window.apiUrl}${url}`);
  }

  getLineItemMeta(params: string): Observable<any> {
    const url = `${window.apiUrl}/api/get_lineitems_meta${params}`; // TODO need to update
    return this.http.get(url);
  }

  getOtherDimensionsMeta(params: string): Observable<any> {
    return this.http.get(`${window.apiUrl}/api/get_other_dim_meta${params}`);
  }

  getPeriodsMeta(params: string): Observable<any> {
    return this.http.get(`${window.apiUrl}/api/get_period_meta${params}`);
  }

  getSourceMeta(params): Observable<any> {
    return this.http.get(`${window.apiUrl}/api/get_source_meta${params}`);
  }

  getGridTabs(ticker: string, cut: string, source?: string): Observable<any> {
    const params = [];
    params.push(`ticker=${ticker}`);
    params.push(`cut=${cut}`);

    if (source) {
      params.push(`source=${source}`);
    }

    return this.http.get(`${window.apiUrl}/api/get_tabs?${params.join("&")}`);
  }

  displayMetaError(msg) {
    if (!msg)
      msg = "There is an error for this context....please try another one";
    //temporary
    //msg = "No data available.";
    $("<div class='metaError'></div>").appendTo($(".contentSection"));
    $(`<div style="font-size:20px;">${msg.message}</div>`).appendTo(
      $(".metaError"),
    );
    if (msg.show_request && msg.show_request === "true") {
      const mailCut = msg.cut;
      const mailTicker = msg.ticker;
      const mailSource = msg.source;
      $(
        `${
          '<div style="font-size:20px">Please <a style="color: #2d709c;font-size: 20px;cursor:pointer" onclick="requestViewMail(' +
          "'"
        }${mailTicker}'` +
          `,` +
          `'${mailSource}'` +
          `,` +
          `'${mailCut}'` +
          `)">click here</a> to request.</div>`,
      ).appendTo($(".metaError"));
    }

    if (msg.ticker && msg.ticker !== "") {
      $(
        '<div style="font-size:10px">You will be redirected to company home page in <span id="secs">5</span> seconds</div>',
      ).appendTo($(".metaError"));
    } else {
      $(
        '<div style="font-size:10px">You will be redirected to home page in <span id="secs">5</span> seconds</div>',
      ).appendTo($(".metaError"));
    }

    const gotoHome = function (ticker) {
      let escapedTicker = "";
      const escapeliteral = "{fslash}";
      if (ticker && ticker !== "") {
        if (ticker.indexOf("/") !== -1) {
          escapedTicker = ticker.replace("/", escapeliteral);
          escapedTicker = encodeURIComponent(escapedTicker);
        } else {
          escapedTicker = encodeURIComponent(ticker);
        }
        window.location.href = `/company/${escapedTicker}`;
      } else {
        window.location.href = "/home";
      }
    };
    setTimeout(function () {
      gotoHome(msg.ticker);
    }, 5000);

    $("#secs").each(function () {
      $(this).animate(
        {
          Counter: 5,
        },
        {
          duration: 5000,
          easing: "swing",
          step: function (now) {
            $(this).text(Math.ceil(5 - now));
          },
        },
      );
    });
  }

  /**
   *
   * @param dapIds array of numbers - i.e. array of dapparameter ids
   * @param ticker string - ticker of current company
   * @returns GetUsliIdsResponse
   * It takes in company id and list of dap parameter ids and returns
   * a list of unique sli ids for the corresponding dapparameter ids
   * There can be more than one unique sli ids for a given dapparameter id
   */
  loadUsliIds(dapIds, ticker): Observable<GetUsliIdsResponse> {
    const payload = {
      ticker: ticker,
      dapparameterids: dapIds,
    };
    return this.http.post<GetUsliIdsResponse>(
      `${window.apiUrl}/api/get_usliids_for_dapparameterids`,
      payload,
    );
  }

  getResearchDocumentsForDp(params) {
    const url = `${window.apiUrl}/api/get_documents_for_dapparameters`;
    return this.http.post(url, params);
  }

  getSentenceInstances(payload) {
    const url = `${window.apiUrl}/api/get_sentences_for_document`;
    return this.http.post(url, payload);
  }
  setUserSelectionForInstance(payload) {
    const url = `${window.apiUrl}/api/research_save_user_selection`;
    return this.http.post(url, payload);
  }
}
